__turbopack_context__.v({
  "filtersBtn": "corporateBondScreenerHeader-module-scss-module__ZU1zJG__filtersBtn",
  "filtersBtnLabel": "corporateBondScreenerHeader-module-scss-module__ZU1zJG__filtersBtnLabel",
  "search": "corporateBondScreenerHeader-module-scss-module__ZU1zJG__search",
  "selectView": "corporateBondScreenerHeader-module-scss-module__ZU1zJG__selectView",
  "tabSelect": "corporateBondScreenerHeader-module-scss-module__ZU1zJG__tabSelect",
});
